<template>
  <div class="search-form">
    <b-row>
      <b-col cols="3" class="pr-0">
        <slot name="left" />
      </b-col>
      <b-col cols="7" class="pl-2">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('list_search_placeholder')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot name="right" />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="900px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form
        ref="form"
        :model="form"
        label-width="125px"
        label-position="left"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_expoMeetingStatus') || '状态'">
              <el-checkbox-group v-model="form.listExpoMeetingStatus">
                <el-checkbox label="N">
                  {{ $l('form_label_expoMeetingStatus_N') || '待预约' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('form_label_expoMeetingStatus_Y') || '已确认' }}
                </el-checkbox>
                <el-checkbox label="P">
                  {{ $l('form_label_expoMeetingStatus_P') || '进行中' }}
                </el-checkbox>
                <el-checkbox label="E">
                  {{ $l('form_label_expoMeetingStatus_E') || '已结束' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('form_label_expoMeetingStatus_D') || '已取消' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_purposeOrIssue') || '会议主题'"
            >
              <el-input
                v-model.trim="form.purposeOrIssue"
                :placeholder="$l('form_placeholder_purposeOrIssue')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custCode') || '客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelectByStatus"
                :body="{ dictType: ['W', 'P', 'B', 'Y'] }"
                :placeholder="$l('form_placeholder_custCode')"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_customerName') || '客户人员'">
              <el-input
                v-model.trim="form.customerName"
                :placeholder="$l('form_placeholder_customerName')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_attendanceCodeList') || '参会人员'"
            >
              <dict-select
                v-model="form.attendanceCodeList"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_attendanceCodeList')"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_merchandiserCodeList') || '业务更单'"
            >
              <dict-select
                v-model="form.merchandiserCodeList"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_merchandiserCodeList')"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_meetingImportantLevel') || '重要程度'"
            >
              <dict-select
                v-model="form.listMeetingImportantLevel"
                url="/master/common/dict/biz"
                :body="{ dictType: 'meetingImportantLevel' }"
                :placeholder="$l('form_placeholder_meetingImportantLevel')"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_meetingTimeZone') || '会议时区'"
            >
              <dict-select
                v-model="form.meetingTimeZone"
                url="/master/common/dict/biz"
                :body="{ dictType: 'meetingTimeZone' }"
                :placeholder="$l('form_placeholder_meetingTimeZone')"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_meetingDate') || '会议日期'">
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.meetingDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('form_placeholder_data') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.meetingDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('form_placeholder_data') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_createDate') || '创建时间'">
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('form_placeholder_data') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('form_placeholder_data') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
              <el-row :gutter="0">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('form_placeholder_data') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('form_placeholder_data') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = { keyword: '', listExpoMeetingStatus: ['N', 'Y', 'P','E'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
